function ConnectionType() {
    this.Title = "reasons for this";
}
if (typeof exports !== 'undefined') {
    module.exports = ConnectionType;
}